import {COOKIE_OID, getCookie} from '@utils/cookies';
import {safeLocalStorage} from '@utils/safeStorages';
import {ReadonlyURLSearchParams} from 'next/navigation';

import {OMICRON_PARAMS, USER_ID} from '@web-catalog/api/omicronApi/constants';
import {OmicronConfigSchema} from '@web-catalog/api/omicronApi/types';

export const getOidSegments = () => {
  try {
    const segments: Record<string, string> = JSON.parse(
      safeLocalStorage.getItem(OMICRON_PARAMS) as string,
    );

    return segments;
  } catch (e) {
    return {};
  }
};

export const getOid = () => {
  return safeLocalStorage.getItem(USER_ID) || '';
};

export const setOidSegments = (data: Record<string, string> | undefined) => {
  if (data) {
    safeLocalStorage.setItem(OMICRON_PARAMS, JSON.stringify(data));
  }

  const userId = getCookie(COOKIE_OID);

  if (userId) {
    safeLocalStorage.setItem(USER_ID, userId);
  }
};

export const extractConfigOverridesFromQuery = (
  params: ReadonlyURLSearchParams,
) =>
  Object.entries(OmicronConfigSchema).reduce(
    (
      acc,
      [
        key,
        {
          value: {is, fallback},
        },
      ],
    ) => {
      const value = params.get(key);
      if (!value) {
        return acc;
      }
      if (typeof fallback === 'boolean') {
        if (['true', 'false'].includes(value.toLowerCase())) {
          acc[key] = value.toLowerCase() === 'true';
        } else {
          console.warn(
            `Incorrect type of config override for key ${key}, expected boolean`,
            value,
          );
        }
      } else if (typeof fallback === 'string') {
        // run is to check for string union types
        if ((is as (v: unknown) => unknown)(value as unknown)) {
          acc[key] = value;
        } else {
          console.warn(`Incorrect string union value provided for key ${key}`);
        }
      } else if (typeof fallback === 'object') {
        try {
          const obj = JSON.parse(value);
          if (is(obj)) {
            acc[key] = obj;
          } else {
            console.warn(`Object failed validation for ${key}`, obj);
          }
        } catch (e) {
          console.warn(`Failed to parse ${key} = ${value}`);
        }
      } else {
        console.warn(
          `Unsupported type of config override for key ${key}`,
          typeof fallback,
        );
      }
      return acc;
    },
    {} as Record<string, unknown>,
  );
